import { render, staticRenderFns } from "./teachingpoint.vue?vue&type=template&id=739ea5f7&scoped=true&"
import script from "./teachingpoint.vue?vue&type=script&lang=js&"
export * from "./teachingpoint.vue?vue&type=script&lang=js&"
import style0 from "./teachingpoint.vue?vue&type=style&index=0&id=739ea5f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739ea5f7",
  null
  
)

export default component.exports